export enum ErrorCodes {
    NoError = 0,
    InvalidUserToken = 100,
    Property_Access_Denied = 101,
    NotAuthorized = 102,
    NotFound = 200,
    ServerError = 500,
    ValidationError = 1000,
    ForbiddenAccess = 108,
}

export enum MasterDataTypes {
    Countries = 1,
    AccountTypes = 2,
}

export enum Modules {
    NoService = 1,
    Glitch = 2,
    Guests = 3,
    StaffHealth = 7,
    Maintenance = 8,
    ServiceAnalytics = 9,
    GlitchAnalytics = 10,
    HKAnalytics = 11
}

export enum CallStatuses {
    Register = "REG",
    Close = "CLS",
    Park = "PRK",
    Open = "OPN",
    Unassigned = "USN",
    StaffNotLoggedIn = "SNL",
}

export enum JobOperationActions {
    None = 0,
    Register = 1,
    Close = 2,
    Park = 3,
    ReAssign = 4,
    Reset = 5,
    Reopen = 6,
    AddRemarks = 7,
    ChangeAttachments = 8,
    Seen = 9,
    SendMessage = 10,
    MessageStatusUpdate = 11,
}

export class RECURRENCE_ROOMSTATUS {
    public static ROOMSTATUS_OCCUPIED: string = "O";
    public static ROOMSTATUS_VACANT: string = "V";
    public static ROOMSTATUS_BOTH: string = "A";
}

export enum EntityCodes {
    None = "",
    Location = "Location",
    CallCategories = "CallCategories",
    CallDescriptions = "CallDescriptions",
    Staff = "Staff",
    Reason = "Reason",
    Dept = "Dept",
    DeviceType = "DeviceType",
    ComplainSatuses = "ComplainStatus",
    Desg = "Desg",
    Sections = "Sections",
    Skill = "Skill",
    Priority = "Priority",
    Vip = "Vip",
    Complain = "Complain",
    EventMaster = "EventMaster",
    Guest = "Guest",
    Reservation = "Reservation",
    GlitchActionReason = "GlitchActionReason",
    GlitchCategories = "GlitchCategories",
    GlitchDescriptionMaster = "GlitchDescriptionMaster",
    GlitchRecoveryOptionMaster = "GlitchRecoveryOptionMaster",
    GlitchRegistrationTypes = "GlitchRegistrationTypes",
    GuestTemperamentMaster = "GuestTemperamentMaster",
    Glitch = "Glitch",
    Name = "Name",
    Email = "Email",
    Mobile = "Mobile"
}

export enum RecurrencePatterns {
    Hourly = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4,
}

export enum RecurrencePatterns_End {
    EndBy = 1,
    EndsAfter = 2,
    NoEndDate = 3,
    //OnCheckout = 3
}

export enum RecurrenceSort {
    CreatedOnAsc = 'CreatedOn asc',
    CreatedOnDesc = 'CreatedOn desc',
    LastUpdateTimeAsc = 'LastUpdateTime asc',
    LastUpdateTimeDesc = 'LastUpdateTime desc',
    StartDateTimeAsc = 'StartDateTime asc',
    StartDateTimeDesc = 'StartDateTime desc',
    EndDateTimeAsc = 'EndDateTime asc',
    EndDateTimeDesc = 'EndDateTime desc',
    ClosedDateTimeAsc = 'ClosedDateTime asc',
    ClosedDateTimeDesc = 'ClosedDateTime desc',
    ReopenDateTimeAsc = 'ReopenDateTime asc',
    ReopenDateTimeDesc = 'ReopenDateTime desc',
}


export enum RecurrenceSortLabel {
    CreatedOnAsc = 'BTN.BTN_CREATED_ON_ASC',
    CreatedOnDesc = 'BTN.BTN_CREATED_ON_DESC',
    LastUpdateTimeAsc = 'BTN.BTN_LAST_UPDATETIME_ASC',
    LastUpdateTimeDesc = 'BTN.BTN_LAST_UPDATETIME_DESC',
    StartDateTimeAsc = 'BTN.BTN_START_DATETIME_ASC',
    StartDateTimeDesc = 'BTN.BTN_START_DATETIME_DESC',
    EndDateTimeAsc = 'BTN.BTN_END_DATETIME_ASC',
    EndDateTimeDesc = 'BTN.BTN_END_DATETIME_DESC',
    ClosedDateTimeAsc = 'BTN.BTN_CLOSED_DATETIME_ASC',
    ClosedDateTimeDesc = 'BTN.BTN_CLOSED_DATETIME_DESC',
    ReopenDateTimeAsc = 'BTN.BTN_REOPEN_DATETIME_ASC',
    ReopenDateTimeDesc = 'BTN.BTN_REOPEN_DATETIME_DESC',
}

export enum ComplainSearch_GroupBy {
    None = 0,
    Location = 1,
    Sections = 2,
    AssignedTo = 3,
    Dept = 4,
    CallCategories = 5,
    CallDescriptions = 6,
    Property = 7,
    Priority = 8
}

export enum GlitchSearch_GroupBy {
    None = 0,
    Location = 1,
    Dept = 2,
    GlitchCategories = 3,
    GlitchDescriptionMaster = 4,
    Property = 5,
}

export enum RecurrenceSearch_GroupBy {
    None = 0,
    Location,
    Dept,
    CallCategories,
    CallDescriptions,
    Property
}

export enum Priorities {
    Normal = 1,
    Urgent = 2,
    XtraUrgent = 3,
    Crisis = 4,
}

export enum WorkOrderStatuses {
    Created = 1,
    Started = 2,
    Assigned = 3,
    Parked = 5,
    Closed = 7,
    Cancelled = 8,
    AwaitingAudit = 9,
    AwaitingAssetAssignment = 11,
    PendingApproval = 12,
    Approved = 13,
    InProgress = 14,
    Reject = 15,
    AwaitingApproval = 16,
    LinkWOCreated = 17,
  }
  
  export enum WOSourceStatuses {
    Service = 1,
    PM = 2,
    Corrective = 3,
  }
  
export enum ComplainType {
    Query = 1,
    ServiceRequest = 2,
    Complaint = 3,
    Maintenance = 4,
}

export enum FilterTypes {
    CallDescription = 1,
    CallCategory = 2,
    Location = 3,
    Dept = 4,
    AssignedTo = 5,
    ReportedBy = 6,
    LoggedBy = 7,
    Sections = 8,
    Vip = 9,
    IsGuestCall = 10,
    RoomStatus = 11,
    EndPattern = 12,
    NextOccurrence = 13,
    HasGlitch = 14,
    GlitchCategory = 15,
    GlitchDescription = 16,
    GlitchStaff = 17,
    HasInvestigation = 18,
    HasRecovery = 19,
    IsKMTCategory = 20,
    HasAttachment = 21,
    HasEscalation = 22,
    TaggedStaffIds = 23,
    RegisteredBy = 24,
    StaffsInvolved = 25,
    Pax = 26,
    HasJobs = 27,
    HasMembership = 28,
    Priority = 29,
    LoggedDate = 30
}

export enum SendMessageDestinationTypes {
    Staff = 1,
    Group = 2,
}

export class MasterConstants {
    public static ATTACHMENT_ACCEPTED_TYPES: Array<string> = [
        "JPG",
        "JPEG",
        "PNG",
        "DOC",
        "DOCX",
        "PDF",
        "XLS",
        "XLSX",
        "CSV",
        "TXT",
    ];
    public static IMAGE_TYPES: Array<string> = ["JPG", "JPEG", "PNG", "GIF"];

    public static IsInAcceptedAttachments(extension: string): boolean {
        if (extension == null) return false;

        extension = extension.toUpperCase();

        let arr = MasterConstants.ATTACHMENT_ACCEPTED_TYPES.filter((a) => {
            return a == extension;
        });

        return arr.length > 0;
    }

    public static GetAcceptedExtensionsAsString(): string {
        return MasterConstants.ATTACHMENT_ACCEPTED_TYPES.join(", ");
    }

    public static IsImage(FileName: string): boolean {
        if (FileName == null) return false;

        FileName = FileName.toUpperCase();

        let arr = MasterConstants.IMAGE_TYPES.filter((a) => {
            return FileName.endsWith("." + a);
        });

        return arr.length > 0;
    }

    public static GetAcceptedImageExtensionsAsString(): string {
        return MasterConstants.IMAGE_TYPES.join(", ");
    }
}

export enum AlertType {
    CheckIn = 1,
    CheckOut = 2,
}

export enum ShiftSetup_LogoutOptions {
    SAME_STAFF_ON_LOGIN = 0,
    NEXT_AVAILABLE_STAFF = 1,
    MANUAL_REASSIGN = 2,
}

export enum DeviceTypes {
    PC = 1,
    Pager = 2,
    Email = 3,
    SMS = 4,
    IP = 5,
    MobileApp = 6,
}

export enum DeviceAllocationTypes {
    Primary = 1,
    Backup = 2,
}

export class AuthActionCodes {
    public static CallAttachment_ADD: string = "CA_ADD";
    public static CallAttachment_DELETE: string = "CA_DEL";
    public static CallClose: string = "CALL_CLO";
    public static CallGSRAudit: string = "CALL_GSR";
    public static CallParking: string = "CALL_PRK";
    public static CallPrinting: string = "CALL_PRN";
    public static CallReassign: string = "CALL_RAS";
    public static CallReopen: string = "CALL_ROPN";
    public static CallReset: string = "CALL_RST";
    public static CallConsoleView: string = "CALL_VW";
    public static TagStaff: string = "CLCON_TS";
    public static CopyToGlitch: string = "COPY_GL";
    public static CallAttachment_Register: string = "CREG_CATT";
    public static CallPark: string = "CREG_CP";
    public static DeleteGuestPreference: string = "CREG_DELGP";
    public static Call_GuestProfileSlider: string = "CREG_GPS";
    public static ManualAssign: string = "CREG_MASN";
    public static QuickCall: string = "CREG_QCK";
    public static CallRecurrence: string = "CREG_REC";
    public static CallRegistration: string = "CREG_REG";
    public static TagStaff_Call: string = "CREG_TS";
    public static CustomizeGuestProfile: string = "CZE_GSTPRO";
    public static GlitchAttachment_ADD: string = "GA_ADD";
    public static GlitchAttachment_DELETE: string = "GA_DEL";
    public static GlitchClose: string = "GL_CLO";
    public static GlitchCopy: string = "GL_COPY";
    public static GlitchDelete: string = "GL_DEL";
    public static GlitchEdit: string = "GL_EDIT";
    public static GlitchGSR: string = "GL_GSR";
    public static GlitchInvestigation: string = "GL_INV";
    public static GlitchPrint: string = "GL_PRN";
    public static GlitchRecovery: string = "GL_REC";
    public static GlitchReopen: string = "GL_ROPN";
    public static GlitchView: string = "GL_VW";
    public static TagStaff_GlitchConsole: string = "GLCON_TS";
    public static GlitchAttachment: string = "GREG_ATT";
    public static Glitch_GuestProfileSlider: string = "GREG_GPS";
    public static GlitchRegistration: string = "GREG_REG";
    public static TagStaff_GlitchReg: string = "GREG_TS";
    public static GroupMessage: string = "GRP_MSG";
    public static GuestImage: string = "GST_IMG";
    public static FrontOffice: string = "GST_LST";
    public static GuestMessage: string = "GST_MSG";
    public static ManualUploadGuestData: string = "GST_ONQ";
    public static GuestImageUploader: string = "GUEST_IM";
    public static TagStaff_Guest: string = "GUESTL_TS";
    public static GuestHistory_KSV_KG = "GL_KSVKG";
    public static GuestProfile_Info = "GL_GPI";
    public static GuestReservation_Info = "GL_GRI";
    public static FrontOffice_Mobile: string = "MOB_FO";
    public static GlitchAttachment_Mobile: string = "MOB_GLA";
    public static GuestHistory: string = "MOB_GSTH";
    public static Housekeeping: string = "MOB_HK";
    public static MyAlerts: string = "MOB_MA";
    public static MinibarPosting: string = "MOB_MP";
    public static RoomHistory: string = "MOB_RH";
    public static RoomStatusPosting: string = "MOB_RSP";
    public static RevenueReport: string = "MOB_RVR";
    public static MobileClientSetup: string = "MOB_SET";
    public static Whiteboard: string = "MOB_WHT";
    public static MessageFormat: string = "MSG_FOR";
    public static QuickCallSetup: string = "QCK_SET";
    public static RecurrenceRemove: string = "REC_DEL";
    public static RecurrenceEdit: string = "REC_EDIT";
    public static RecurrencePrint: string = "REC_PRN";
    public static RecurrenceView: string = "REC_VW";
    public static PostRoomStatus: string = "RPOST ";
    public static EditHKReports: string = "ED_HK_RPO";
    public static CreateKnowGlitchReports: string = "RPT_GL_CRT";
    public static DeleteKnowGlitchReports: string = "RPT_GL_DEL";
    public static EditKnowGlitchReports: string = "RPT_GL_EDT";
    public static RunKnowGlitchReports: string = "RPT_GL_RUN";
    public static ScheduleKnowGlitchReports: string = "RPT_GL_SCH";
    public static ViewKnowGlitchReports: string = "RPT_GL_VW";
    public static CreateAdvancedKnowServiceReports: string = "RPT_RR_CRT";
    public static DeleteAdvancedKnowServiceReports: string = "RPT_RR_DEL";
    public static EditAdvancedKnowServiceReports: string = "RPT_RR_EDT";
    public static RunKnowServiceReports: string = "RPT_RR_RUN";
    public static ScheduleKnowServiceReports: string = "RPT_RR_SCH";
    public static ViewKnowServiceReports: string = "RPT_RR_VW";
    public static RunUtilityReports: string = "RPT_UT_RUN";
    public static ViewUtilityReports: string = "RPT_UT_VW";
    public static SendtoEMS: string = "SEND_EMS";
    public static StaffMessage: string = "STF_MSG";
    public static AutoCall_ADD: string = "SYS_ACADD";
    public static AutoCall_DELETE: string = "SYS_ACDEL";
    public static AutoCall: string = "SYS_ACR";
    public static AutoCall_EDIT: string = "SYS_ACUPD";
    public static CallManager_ADD: string = "SYS_CMADD";
    public static CallManager_DELETE: string = "SYS_CMDEL";
    public static CallManager: string = "SYS_CMGR";
    public static CallManager_EDIT: string = "SYS_CMUPD";
    public static EscalationManager_ADD: string = "SYS_EMADD";
    public static EscalationManager_DELETE: string = "SYS_EMDEL";
    public static EMSSetup: string = "SYS_EMS";
    public static EMSSetup_ADD: string = "SYS_EMSADD";
    public static EscalationManager_EDIT: string = "SYS_EMUPD";
    public static EscalationManager: string = "SYS_ESCT";
    public static GlitchSetup_ADD: string = "SYS_GLADD";
    public static GlitchSetup_DELETE: string = "SYS_GLDEL";
    public static GlitchSetup: string = "SYS_GLSET";
    public static GlitchSetup_EDIT: string = "SYS_GLUPD";
    public static GroupMessaging_ADD: string = "SYS_GMADD";
    public static GroupMessaging_DELETE: string = "SYS_GMDEL";
    public static GroupMessaging_EDIT: string = "SYS_GMUPD";
    public static GroupMessaging: string = "SYS_GRPMSG";
    public static InterfaceSettings: string = "SYS_INSET";
    public static Alert_ADD: string = "SYS_PADD";
    public static Alert_DELETE: string = "SYS_PMDEL";
    public static Alert: string = "SYS_PMS";
    public static Alert_EDIT: string = "SYS_PMUPD";
    public static Systemparameter: string = "SYS_PRM";
    public static Systemparameter_ADD: string = "SYS_PRMADD";
    public static Systemparameter_DELETE: string = "SYS_PRMDEL";
    public static Systemparameter_EDIT: string = "SYS_PRMUPD";
    public static PasswordRules: string = "SYS_PWDRUL";
    public static QuestionMaster_CALL_ADD: string = "SYS_QMCADD";
    public static QuestionMaster_CALL_EDIT: string = "SYS_QMCUPD";
    public static QuestionMaster_GLITCH_ADD: string = "SYS_QMGADD";
    public static QuestionMaster_GLITCH_EDIT: string = "SYS_QMGUPD";
    public static QuestionMaster_CALL: string = "SYS_QMSTC";
    public static QuestionMaster_GLITCH: string = "SYS_QMSTG";
    public static UserModuleRights_EDIT: string = "SYS_RGHTUP";
    public static UserModuleRights: string = "SYS_RIGHT";
    public static Add_EditRole: string = "SYS_ROLE1";
    public static ApplyRole: string = "SYS_ROLE2";
    public static EscalationRules_ADD: string = "SYS_RULADD";
    public static EscalationRules_COPY: string = "SYS_RULCOP";
    public static EscalationRules_DELETE: string = "SYS_RULDEL";
    public static EscalationRules: string = "SYS_RULES";
    public static EscalationRules_PRIORITY: string = "SYS_RULPRI";
    public static EscalationRules_EDIT: string = "SYS_RULUPD";
    public static SkillManager_ADD: string = "SYS_SKADD";
    public static SkillManager_DELETE: string = "SYS_SKDEL";
    public static SkillManager: string = "SYS_SKMGR";
    public static SkillManager_EDIT: string = "SYS_SKUPD";
    public static SectionManager_ADD: string = "SYS_SMADD";
    public static SectionManager_DELETE: string = "SYS_SMDEL";
    public static SectionManager: string = "SYS_SMGR";
    public static SectionManager_EDIT: string = "SYS_SMUPD";
    public static SOPManager: string = "SYS_SOP";
    public static SOPManager_ADD: string = "SYS_SOPADD";
    public static SOPManager_DELETE: string = "SYS_SOPDEL";
    public static SOPManager_EDIT: string = "SYS_SOPUPD";
    public static StaffManager_ADD: string = "SYS_STADD";
    public static StaffManager_DELETE: string = "SYS_STDEL";
    public static StaffManager: string = "SYS_STMGR";
    public static StaffManager_EDIT: string = "SYS_STUPD";
    public static TemplateUserModule: string = "SYS_TMP";
    public static Template_ADD: string = "SYS_TMPADD";
    public static Template_DELETE: string = "SYS_TMPDEL";
    public static Template_EDIT: string = "SYS_TMPUPD";
    public static UserAccount: string = "SYS_USR";
    public static SystemConfigurationView: string = "SYS_VW";
    public static ZoneManager_ADD: string = "SYS_ZMADD";
    public static ZoneManager_DELETE: string = "SYS_ZMDEL";
    public static ZoneManager: string = "SYS_ZMGR";
    public static ZoneManager_EDIT: string = "SYS_ZMUPD";
    public static TranslationManager: string = "TRAN_MAN";
    public static ShiftActivate: string = "TSS_ACT";
    public static MapStaff: string = "TSS_MS";
    public static Non_ServiceStaff_EditDeviceType: string = "TSS_NEDT";
    public static Non_ServiceStaff_Login_Logout: string = "TSS_NLOG";
    public static SaveShift: string = "TSS_SAVE";
    public static ServiceStaff_EditDeviceType: string = "TSS_SEDT";
    public static ServiceStaff_Login_Logout: string = "TSS_SLOG";
    public static ShiftSetupview: string = "TSS_VW";
    public static AuthorizedWebClientView: string = "WEB_AUT";
    public static StaffHealth_MANAGE = "HLT_EDT";
}

export enum MessageOperations {
    Sent = 1,
    Read = 2,
    Delivered = 3,
}

export enum SessionChangeEvents {
    Expire = 1,
    DuplicateLogin = 2,
}

export enum JobSearch_Compact_Mode {
    Location = 1,
    Guest = 2,
}

export enum JobPopoverMode {
    Default = 1,
    ReadOnly = 2,
}

export class ModuleLicenceCodes {
    public static TritonRapidResponse: string = "TTN_RRESP";
    public static TritonCore: string = "TTN_CORE";
    public static TritonGlitch: string = "TTN_GLIT";
    public static TritonFrontOffice: string = "TTN_GUEST";
    public static KMTCore = "KMT_CORE";
    public static Inventory = "UF_INV";
}
export enum InventoryItemTypes {
    Consumables = 1,
    Reservables = 2
}

export enum InventoryItemType {
    Reusable = 'Reusable',
    Consumables = 'Consumables'
}

export enum InventoryTransactionTypes {
    Reserve = 1,
    UnReserve = 2,
    Consume = 3,
}

export enum GlitchOperationActions {
    Register = 1,
    Edit = 2,
    Close = 3,
    AddRecovery = 4,
    EditRecovery = 5,
    AddInvestigation = 6,
    EditInvestigation = 7,
    Delete = 8,
    EditAttachment = 9,
    ReOpen = 10,
    DeleteRecovery = 11,
    DeleteInvestigation = 12,
    ReOpenEdit = 13,
    ReOpenDelete = 14,
    CloseEdit = 15,
    CloseDelete = 16,
    Copy = 17,
}

export enum Glitch_RegistrationTypes {
    Visitor_Guest = 0,
    In_House_Guest = 1,
    CheckedOut_Guest = 2,
    PreArrival_Guest = 3,
    Staff = 5,
}

export enum VisitorSearchCharLimit {
    FName = 3,
    LName = 3,
    Email = 6,
    MobileNumber = 7
}

export enum GlitchStatuses {
    Open = 1,
    Close = 2,
    Important = 3,
}

export enum JobConsole_Search_Mode {
    Default = 1,
    Crisis = 2,
}

export enum QuestionSetStatus {
    Pending = "PENDING",
    Active = "ACTIVE",
    Disabled = "DEACTIVE",
    Deleted = "DELETED",
}

export enum AnswerTypes {
    Numerical = "numerical",
    OptionalBool = "optional-bool",
    Rating = "rating",
    Checkbox = "checkbox",
    Radio = "radio",
    Text = "text",
}

export class AnswerTypesUtil {
    static getLabel(type: AnswerTypes) {
        switch (type) {
            case AnswerTypes.Text:
                return "LBL.RESPONSE_TEXT";
            case AnswerTypes.Numerical:
                return "LBL.RESPONSE_NUMERICAL";
            case AnswerTypes.OptionalBool:
                return "LBL.RESPONSE_BINARY";
            case AnswerTypes.Rating:
                return "LBL.RESPONSE_RATING";
            case AnswerTypes.Radio:
                return "LBL.RESPONSE_RADIO";
            case AnswerTypes.Checkbox:
                return "LBL.RESPONSE_CHECKBOX";
        }
    }
}

export enum EntityCreationMode {
    Page = 1,
    Compact,
    Expanded,
}

export enum ShiftSetupLoadOptions {
    CommonSkills = "CommonSkills",
    ShiftSkills = "ShiftSkills",
}
